import axios from 'axios';
import cfg from '../config';

let config;
if (cfg.useCors === true) {
  config = { baseURL: cfg.apiUrl };
}
export default axios.create(config);
